// extracted by mini-css-extract-plugin
export default {"container":"index_container__ZuESM","card":"index_card__4-qiq"};